// @flow
import React from 'react';
import { formElement } from '../../../lib/styles';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { IconButton } from 'material-ui';
import Video from 'material-ui/svg-icons/av/videocam';
import PopupGallery from '../../media/PopupGallery';
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable';
import Preview from '../../preview/Preview';

type CombinedPreviewVideoProps = {
    onValueChange: () => void,
    preview: { id?: string, filename?: string, description?: string },
};

export class CombinedPreviewVideo extends React.Component<CombinedPreviewVideoProps> {
    state = {
        previewAttribution: '',
        previewPicture: '',
        isOpened: false
    }

    render() {
        const {isOpened} = this.state;
        const preview = O.fromNullable(this.props.preview);

        return (
            <div>
                <small style={{ ...formElement.small, display: 'block', marginTop: 19 }}>
                    Видео для превью
                </small>

                {pipe(
                    preview,
                    O.fold(() => (
                        <section
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: '6px 2px 1px 0',
                                borderBottom: 'solid 1px #E0E0E0',
                            }}
                        >
                            <ContentAdd />
                            <IconButton onClick={this.handleClick}
                                containerElement="label"
                                style={{ maxWidth: 12, height: 42, padding: 9 }}
                                className="btn__hover_empty">
                                <Video />
                            </IconButton>
                        </section>
                    ), (preview) => this.renderPreviewPicture(preview))
                )}

                <PopupGallery
                    open={isOpened}
                    type={['video']}
                    closeDialogHandle={this.handleClose}
                    insertMediaFile={(item) => {
                        this.insertMediaFile(item);
                        setTimeout(() => {
                            this.handleClose();
                        }, 250);
                    }}
                    insertAfterUpload
                />

            </div>
        )
    }

    renderPreviewPicture = (preview) => {
        const {previewPicture} = this.state;
        let previewPath = previewPicture || '';
        let mediaId = '';

        if (preview) {
            previewPath = preview.filename;
            mediaId = preview.id;
        }
        return (<Preview
            item={previewPath}
            mediaId={mediaId}
            height={250}
            attr={this.state.previewAttribution || ''}
            showAttr={false}
            removePreview={this.handleRemovePreview}
        />);
    };

    handleRemovePreview = () => {
        const { onValueChange } = this.props;
        onValueChange(O.none);
    }

    insertMediaFile = (file) => {
        const {onValueChange} = this.props;
        const fileData = file;

        fileData.type = fileData.type || fileData.fileType;

        onValueChange(O.some({
            id: fileData.id,
            filename: fileData.filename,
        }));
    }

    handleClose = () => {
        this.setState({ isOpened: false });
    }

    handleClick = () => {
        const { edit } = this.props;
        if (!edit) {
            this.setState({
                isOpened: true,
            });
        }
    };
}


// WEBPACK FOOTER //
// src/components/articles/components/CombinedPreviewVideo.js